import React from 'react';
import { Autocomplete, Box, TextField, styled } from '@mui/material';
import { useJobsContext } from 'components/JobList';
import { useSearchParam } from 'helpers/useSearchParam';

const FilterField = styled(Box)({
  minWidth: 160,
  flex: '1 1 160px',
  maxWidth: 240
});

export default function SelectStatus() {
  const { onStatusChange } = useJobsContext();
  const [status] = useSearchParam('status');

  const options = [
    { value: 'enabled', label: 'Enabled' },
    { value: 'pending', label: 'Pending' },
    { value: 'error', label: 'Error' },
    { value: 'disabled', label: 'Disabled' }
  ];

  const selected = options.find((option) => option.value === status) || null;

  return (
    <FilterField>
      <Autocomplete
        clearOnEscape
        getOptionLabel={(option) => option.label || ''}
        isOptionEqualToValue={(option, selectedValue) =>
          option.value === selectedValue.value
        }
        onChange={(_event, next) => onStatusChange(next?.value || '')}
        options={options}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Status"
            placeholder="Search status"
            size="small"
          />
        )}
        size="small"
        value={selected}
      />
    </FilterField>
  );
}
